import createLucideIcon from '../createLucideIcon';

const ArrowBigLeft = createLucideIcon('ArrowBigLeftIcon', [
  ['path', { d: 'm3 12 7-7v4h11v6H10v4z', key: '1e8ocp' }],
]);

export default ArrowBigLeft;
